import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "oidc-client-ts";
import { RoleName } from "../../types/role";

/**
 * Auth flow
 *
 * The "react-oidc-context" and "oidc-client-ts" libraries are used to
 * manage the authentication flow. They provide a context, a hook (useAuth)
 * and methods to interact with the OpenID Connect protocol.
 *
 * As soon as the user is authenticated, the "userLoaded" event is triggered,
 * we store the user and the role in the Redux store.
 *
 * The components can access the user and the role using the "useAppSelector(state => state.auth)"
 */

type AuthState = {
  user: User | null;
  role: RoleName | null;
};

const initialState: AuthState = {
  user: null,
  role: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    /**
     * Triggered by the OpenID Connect library when a connection
     * is established (login) or re-established (refreshToken)
     */
    userLoaded: (
      state,
      action: PayloadAction<{ user: User; role: RoleName }>,
    ) => {
      state.user = action.payload.user;
      state.role = action.payload.role;
    },
    userUnloaded: () => ({ ...initialState }),
  },
});

export const { userLoaded, userUnloaded } = authSlice.actions;
export default authSlice;
